/* eslint-disable no-shadow */
const state = {
  loadingList: []
};

const mutations = {
  PUSH_LOADING(state, playload) {
    state.loadingList.push({ text: playload || '玩命加载中...' });
  },
  SHIFT_LOADING(state) {
    state.loadingList.shift();
  }
};
const actions = {
  openLoading({ commit }, playload) {
    commit('PUSH_LOADING', playload);
  },
  closeLoading({ commit }) {
    commit('SHIFT_LOADING');
  }
};

const loading = {
  state,
  mutations,
  actions
};

export default loading;
